import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Divider,
  makeStyles,
  CircularProgress,
  Box,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { gpColors } from "../../constants/colors";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import AddNewPartModal from "./AddNewPartModel";
import SideDrawer from "./Drawer";
import { useEffect } from "react";
import { getCookie } from "../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { routes } from "../../constants/routes";

const columns = [
  { id: "id", label: "Part Terminology ID", minWidth: 170 },
  { id: "brand", label: "Part Type", minWidth: 100 },
  {
    id: "population",
    label: "Status",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  // {
  //   id: 'size',
  //   label: 'Size\u00a0(km\u00b2)',
  //   minWidth: 170,
  //   align: 'right',
  //   format: (value) => value.toLocaleString('en-US'),
  // },
  {
    id: "density",
    label: "Action",
    minWidth: 170,
    align: "right",
    format: (value) => value.toFixed(2),
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData("India", "IN", 1324171354, 3287263),
  createData("China", "CN", 1403500365, 9596961),
  createData("Italy", "IT", 60483973, 301340),
  createData("United States", "US", 327167434, 9833520),
  createData("Canada", "CA", 37602103, 9984670),
  createData("Australia", "AU", 25475400, 7692024),
  createData("Germany", "DE", 83019200, 357578),
  createData("Ireland", "IE", 4857000, 70273),
  createData("Mexico", "MX", 126577691, 1972550),
  createData("Japan", "JP", 126317000, 377973),
  createData("France", "FR", 67022000, 640679),
  createData("United Kingdom", "GB", 67545757, 242495),
  createData("Russia", "RU", 146793744, 17098246),
  createData("Nigeria", "NG", 200962417, 923768),
  createData("Brazil", "BR", 210147125, 8515767),
];

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    marginTop: "40px",
    width: "100%",
  },
  container: {
    //maxHeight: 440,
    tableLayout: "auto",
  },
  searchContainer: {
    marginTop: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  button: {
    backgroundColor: "#1779CB",
    textTransform: "none",
    color: "#fff",
    marginBottom: "5px",
    width: "200px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: "#1779CB" },
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    // '&:hover': {
    //   backgroundColor: '#F08080'
    // },
    marginLeft: 0,
    marginBottom: "5px",
    width: "200px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
  tableHead: {
    backgroundColor: gpColors.logoGray,
    color: "#fff",
  },
}));

const Brand = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [userList, setUserList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState({});
  console.log(userList);
  useEffect(() => {
    const getBrandList = async (userVal) => {
      setLoader(true);
      try {
        const resp = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/getBrandsList`,
          {
            method: "GET",
            headers: {
              "Access-Control-Allow-Origin": "*",
              // 'Content-Type': 'application/json',
              // Accept: 'application/json',
              Authorization: `Token ${userVal.loginInfo.data.jwt}`,
              // // "ngrok-skip-browser-warning": "true",
            },
          }
        );
        const data = await resp.json();
        console.log(data);
        setUserList(data);
        setLoader(false);
      } catch (e) {
        console.log(e.message);
        setLoader(false);
      }
    };
    const getLoginInfoData = () => {
      const getValue = getCookie("guardPlus_user");
      if (getValue !== null) {
        const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
        const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
        console.log(userVal);
        setUserData(userVal);
        getBrandList(userVal);
      }
    };
    getLoginInfoData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [searchItem, setSearchItem] = useState("");
  return (
    <div className={classes.roots}>
      <SideDrawer tabName="brand" userData={userData} />
      <main className={classes.content}>
        <div className={classes.title}>Brand parts</div>
        <Divider />

        <div className={classes.searchContainer}>
          <Button
            className={classes.button}
            endIcon={<AddIcon />}
            onClick={() => setModalOpen(true)}
          >
            New Part Type
          </Button>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              onChange={(e) => setSearchItem(e.target.value)}
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
        </div>

        <Paper className={classes.root}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHead}>Id</TableCell>
                  <TableCell className={classes.tableHead} align="left">
                    Brand
                  </TableCell>
                  {/* <TableCell className={classes.tableHead} align="left">Status</TableCell>
            <TableCell className={classes.tableHead} align="left">Action</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {userList.length > 0 &&
                  userList
                    .filter((item) =>
                      item.brand
                        .toLowerCase()
                        .includes(searchItem.toLowerCase())
                    )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((userList) => {
                      return (
                        <TableRow key={userList.id}>
                          <TableCell component="th" scope="row">
                            {userList.id}
                          </TableCell>
                          <TableCell align="left">{userList.brand}</TableCell>
                          {/* <TableCell align="left">Pending</TableCell>
                <TableCell align="left">Update</TableCell> */}
                        </TableRow>
                      );
                    })}
                {loader && (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Box
                        textAlign="center"
                        sx={{
                          color: "#BE0A00",
                          alignItems: "center",
                          backgroundColor: "",
                          display: "flex",
                          justifyContent: "center",
                          height: "20vh",
                        }}
                      >
                        <CircularProgress color="inherit" />
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
                {userList.length == 0 && !loader && (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Box
                        textAlign="center"
                        sx={{
                          alignItems: "center",
                          backgroundColor: "",
                          display: "flex",
                          justifyContent: "center",
                          height: "20vh",
                        }}
                      >
                        No data available
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 20]}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
        <AddNewPartModal
          modalOpen={modalOpen}
          setModalOpen={(flag) => setModalOpen(flag)}
        />
      </main>
    </div>
  );
};
export default Brand;
